export default __webpack_public_path__ + "static/hero-style-04ff91df0135e00f5159d682c9cb20e8.png";